import React from "react";
import { Outlet } from "react-router-dom";
import InvestorSideNav from "../components/InvestorSideNav";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function InvestorLayout({ language, dir = "ltr", currentLangFunc, currentDir }) {
  return (
    <div className="mx-auto" dir={`${dir}`}>
      <ToastContainer />
      <InvestorSideNav
        lang={language}
        dirFormat={dir}
        currentLangFunc={currentLangFunc}
        currentDir={currentDir}
      />
      <main className={`main ${dir === "rtl" ? "main-right" : "main-left"}`}>
        <Outlet />
      </main>
    </div>
  );
}

export default InvestorLayout;
